var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBigArrowRight28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.14645 4.14645C9.34171 3.95118 9.65829 3.95118 9.85355 4.14645L19.8536 14.1464C20.0488 14.3417 20.0488 14.6583 19.8536 14.8536L9.85355 24.8536C9.65829 25.0488 9.34171 25.0488 9.14645 24.8536C8.95118 24.6583 8.95118 24.3417 9.14645 24.1464L18.7929 14.5L9.14645 4.85355C8.95118 4.65829 8.95118 4.34171 9.14645 4.14645Z",
  fill: "currentColor"
})));
export default SvgBigArrowRight28;